export enum PathName {
  home = '/',
  stake = '/stake',
}
